module.exports = __webpack_public_path__ + "static/img/36-2.38eb206.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/36-2.jpg
// module id = SBRP
// module chunks = 0